<template>
  <div v-if="metaVerified || (isDev || isQa)">
    <div v-if="data && !isSecondaryCaregiver">
      <Top />
      <div class="container">
        <div class="row">
          <div class="col-sm"></div>
          <div class="col-md-6">
            <Pagination :numberOfDots="4" :numberOfVisitedDots="1" />
            <img src="@/assets/img/heart.svg?data" alt="Ett FH hjärta" class="img-fluid margin-right-2" />
            <div class="clearfix"></div>
            <div class="header-wrapper" v-if="fullname && fullname.length > 0">
              <h3 class="text-primary-fh left-header">{{ data.welcomepage.greetingsHeader + toTitleCase(fullname) }}!</h3>
            </div>
            <p v-html="data.welcomepage.greetingsText" v-if="!isIndexPatient && !isCardioPatient"></p>
            <p v-html="data.welcomepage.greetingsTextIdx" v-if="isIndexPatient"></p>
            <p v-html="data.welcomepage.greetingsTextCardio" v-if="isCardioPatient"></p>
          </div>
          <div class="col-sm"></div>
        </div>
        <div class="row">
          <div class="col-sm"></div>
          <div class="col-md-6">
            <h4 v-html="data.welcomepage.personaldataHeader" v-if="!isIndexPatient" class="left-header"></h4>
            <h4 v-html="data.welcomepage.personaldataHeaderIdx" v-if="isIndexPatient" class="left-header"></h4>
            <div class="clearfix"></div>
            <p v-html="data.welcomepage.personaldataText" v-if="!isIndexPatient"></p>
            <p v-html="data.welcomepage.personaldataTextIdx" v-if="isIndexPatient"></p>
          </div>
          <div class="col-sm"></div>
        </div>
        <div class="clearfix"></div>
        <div class="row">
          <div class="col-sm"></div>
          <div class="col-md-6">
            <div v-if="age">
              <!-- GDPR / FHabian consent -->
              <div class="card">
                <h4 class="text-primary-fh left-header" v-html="data.welcomepage.consentScreeningText"></h4>
                <div class="clearfix"></div>
                <div class="btn-group btn-group-toggle justify-content-center">
                  <label class="btn btn-outline-secondary btn-lg radio-btn" :class="consent === true ? 'active' : ''">
                    <input class="form-check-input" type="checkbox" v-model="consent"> Ja
                  </label>
                  <br />
                </div>
              </div>
              <div class="clearfix"></div>
              <!-- Forskning consent -->
              <div class="card" v-if="age >= 18">
                <p class="text-primary-fh left-header" v-html="data.welcomepage.consentResearch18Plus"></p>
                <div class="btn-group btn-group-toggle" :class="!consent ? 'btn-group-disabled' : ''">
                  <label class="btn btn-outline-secondary btn-lg btn-block radio-btn" :class="research === true ? 'active' : ''">
                    <input type="radio"
                    v-model="research"
                    v-bind:value="true"
                    autocomplete="off">Ja
                  </label>
                  <div class="clearfix"></div>
                  <label class="btn btn-outline-secondary btn-lg btn-block radio-btn" :class="research === false ? 'active' : ''">
                    <input type="radio"
                    v-model="research"
                    v-bind:value="false"
                    autocomplete="off">Nej
                  </label>
                </div>
              </div>
              <!-- Forskning consent 15-17 år -->
              <div class="card" v-if="age >= 15 && age <= 17">
                <p class="text-primary-fh left-header" v-html="data.welcomepage.consentResearch15to17"></p>
                <div class="btn-group btn-group-toggle" :class="!consent ? 'btn-group-disabled' : ''">
                  <label class="btn btn-outline-secondary btn-lg btn-block radio-btn" :class="research === true ? 'active' : ''">
                    <input type="radio"
                    v-model="research"
                    v-bind:value="true"
                    autocomplete="off">Ja
                  </label>
                  <div class="clearfix"></div>
                  <label class="btn btn-outline-secondary btn-lg btn-block radio-btn" :class="research === false ? 'active' : ''">
                    <input type="radio"
                    v-model="research"
                    v-bind:value="false"
                    autocomplete="off">Nej
                  </label>
                </div>
              </div>
              <!-- Forskning consent 13-15 år -->
              <div class="card" v-if="age > 12 && age < 15">
                <p class="text-primary-fh" v-html="data.welcomepage.consentDisclaimerTextMinor"></p>
                <input
                  id="phone-number-input"
                  class="form-control form-control-lg form-control-block phone-number-input"
                  type="text"
                  placeholder="Telefonnummer"
                  v-model="careGiver.phonenumber"
                  :maxlength="10"
                  @input="enforceNumbers()"
                />
                <div class="clearfix--min"></div>
                <input
                  type="text"
                  class="form-control form-control-lg"
                  v-model="careGiver.email"
                  @input="research = null"
                  :class="((careGiver.email && careGiver.email.length > 0) && !validEmail(careGiver.email)) ? 'invalid' : ''"
                  placeholder="E-post"
                />
                <div class="clearfix--min"></div>
                <button
                  class="btn btn-primary btn-lg btn-block"
                  @click="sendNotificationToCareGiver()"
                  :disabled="!checkIfDirty() || minorHasSentNotification">
                Skicka notis till vårdnadshavare
                </button>
              </div>
              <div class="alert alert-research alert-success clearfix">
              <strong>Din vårdnadshavare har nu blivit notifierad!</strong>
              </div>
              <div class="clearfix"></div>
              <button
                class="btn btn-primary btn-lg btn-block"
                @click="giveConsents()"
                :disabled="!consent || (!minorHasSentNotification && research === null)">
              Nästa
              </button>
              <div class="clearfix"></div>
              <p v-html="data.welcomepage.consentDisclaimerText" v-if="!isIndexPatient"></p>
              <p v-html="data.welcomepage.consentDisclaimerTextIdx" v-if="isIndexPatient"></p>
            </div>
          </div>
          <div class="col-sm"></div>
        </div>
      </div>
      <div class="clearfix"></div>
      <Bottom />
    </div>
    <!-- Secondary caregiver modal -->
    <div v-if="isSecondaryCaregiver && data" class="modal fade wrapper-margin-top"
      id="secondaryCaregiverModal" role="dialog" aria-labelledby="secondaryCaregiverModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="secondaryCaregiverModalLabel">Som vårdnadshavare - ditt samtycke behövs</h5>
            <button type="button" class="close" title="Logga ut" @click="closeModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="!secondaryCaregiverConsent">
              <p v-html="data.welcomepage.personaldataText"></p>
              <div class="clearfix"></div>
              <p class="text-primary-fh" v-html="data.welcomepage.consentScreeningText"></p>
              <div class="clearfix"></div>
              <button class="btn btn-primary btn-lg btn-block"
                :class="secondaryCaregiverConsent === true ? 'active' : ''"
                @click="giveSecondaryCaregiverConsent()">
                Ge samtycke
              </button>
            </div>
            <div v-if="(secondaryCaregiverChildren && secondaryCaregiverChildren.length > 0) && secondaryCaregiverConsent">
              <div class="clearfix m-b-100"></div>
              <h5 class="text-primary-fh text-left" v-if="!hasConsentToBeGiven">
                Du har gett samtycke åt samtliga barn ✓
              </h5>
              <h5 class="text-danger text-left" v-if="hasConsentToBeGiven">
                <strong>Du behöver ge samtycke åt dina barn</strong>
              </h5>
              <p v-if="!hasConsentToBeGiven">
                I listan nedan ser du vilka samtyckesval du gjort.
              </p>
              <p v-if="hasConsentToBeGiven">
                I listan nedan ser du vilka barn som är i behov av din uppmärksamhet.
              </p>
              <select class="form-control" @change="routeToConsentMinor($event)">
                <option :value="0">- Välj barn -</option>
                <option v-for="(child, i) in secondaryCaregiverChildren" :value="child.personId" v-bind:key="i"
                  :class="[getConsentStatus(child) === 'consent-to-give-finished' ? 'text-success' : '',
                  getConsentStatus(child) === 'consent-to-give-remains' ? 'text-danger' : '']">
                    {{ child.firstName + ' ' + child.lastName }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Registration modal -->
    <div class="modal fade wrapper-margin-top"
      id="registerModal" role="dialog" aria-labelledby="registerModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="registerModalLabel" v-if="!hasRegistered">
              Din registrering pågår
            </h5>
            <h5 class="modal-title" id="registerModalLabel" v-if="hasRegistered">
              Din registrering lyckades
            </h5>
            <button type="button" class="close" title="Logga ut" @click="closeModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="register-card" v-if="!hasRegistered">
              <div class="card-body">
                Vänligen vänta medan registering sker..
              </div>
            </div>
            <div class="clearfix--min"></div>
            <div class="alert alert-danger alert-register">
              <strong>Ett fel uppstod, vi beklagar för detta.</strong>
              <div class="clearfix--min"></div>
              <button class="btn btn-primary btn-sm" @click="closeModal()">
                Gå till startsidan
              </button>
            </div>
            <div class="register-card" v-if="hasRegistered">
              <div class="card-body">
                Du har nu tillgång att börja kaskadscreeningen. <br />
                Vänligen stäng detta fönster och fortsätt med samtycke.
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="modal-footer">
              <button v-if="hasRegistered" type="button" class="btn btn-primary" data-dismiss="modal">Stäng</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Alert />
    <vue-cookie-accept-decline
      :ref="'cookies'"
      :elementId="'cookies'"
      :debug="false"
      :position="'bottom-left'"
      :type="'floating'"
      :disableDecline="true"
      :transitionName="'slideFromBottom'"
      :showPostponeButton="false">
      <div slot="message">
        Denna sida använder cookies. <br />
        Läs mer <a href="https://www.pts.se/cookies" target="_blank">här</a>.
      </div>
      <div slot="acceptContent">Jag förstår</div>
    </vue-cookie-accept-decline>
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import Pagination from '../../src/components/Pagination'
import Alert from '../../src/components/Alert'
import { request } from '../plugins/datocms'
import { parseJwt } from '../plugins/jwtparser'
import { tokenWatcher } from '../plugins/tokenwatcher'
import config from '../../config/index.js'
import axios from '../plugins/axios'
import $ from 'jquery'

export default {
  name: 'welcome',
  components: {
    Top,
    Bottom,
    Pagination,
    Alert
  },
  data () {
    return {
      data: null,
      fullname: '',
      age: null,
      patientStates: [],
      metaVerified: false,
      isIndexPatient: false,
      isRelative: false,
      isSecondaryCaregiver: false,
      isCardioPatient: false,
      isGeneNegative: false,
      consent: false,
      hasRegistered: false,
      minorHasSentNotification: null,
      research: null,
      careGiver: {},
      answers: [],
      secondaryCaregiverChildren: [],
      secondaryCaregiverConsent: false,
      isDev: process.env.NODE_ENV === 'dev',
      isQa: process.env.NODE_ENV === 'qa'
    }
  },
  methods: {
    getTokenWithMetaInfo () {
      $('#registerModal').modal('hide')
      let loader = this.$loading.show({
        opacity: 0.9,
        backgroundColor: '#B5B5B5'
      })
      const sessionId = sessionStorage.getItem('sessionId')
      const uri = localStorage.getItem('uri')
      axios.postToken(uri, String(sessionId)).then((response) => {
        if (response) {
          loader.hide()

          sessionStorage.setItem('jwt', response.data.token)
          const decodedJwt = parseJwt(response.data.token)

          if (decodedJwt) {
            sessionStorage.setItem('fullname', decodedJwt.givenName + ' ' + decodedJwt.surName)
            this.fullname = sessionStorage.getItem('fullname')

            this.patientStates.push(
              { name: 'consentscreening', value: (decodedJwt.hasVerifiedConsentScreening === 'true') },
              { name: 'consentsresearch', value: (decodedJwt.hasVerifiedConsentResearch === 'true') },
              { name: 'phonenumber', value: (decodedJwt.hasVerifiedPhoneNumber === 'true') },
              { name: 'invitation', value: (decodedJwt.hasVerifiedInvitation === 'true') },
              { name: 'diagnose', value: (decodedJwt.hasVerifiedDiagnosis === 'true') },
              { name: 'gentest', value: (decodedJwt.hasVerifiedGeneticTest === 'true') },
              { name: 'mutation', value: (decodedJwt.hasVerifiedMutation === 'true') }
            )

            this.getPatientRole(decodedJwt)
            localStorage.setItem('remittance', decodedJwt.hasBloodTestReferral)
            localStorage.setItem('age', decodedJwt.age)
            localStorage.removeItem('registerRelative')
            this.age = decodedJwt.age
            /* This is temporary. When Skåne is back on, comment below lines back! */
            // sessionStorage.setItem('region', decodedJwt.region)
            // this.$root.$emit('setRegion', decodedJwt.region)
            sessionStorage.setItem('isIndexPatient', this.isIndexPatient)
            sessionStorage.setItem('isSecondaryCaregiver', this.isSecondaryCaregiver)
          }
          /* If you're a relative, get screeninganswers and decide
             route by state with answers in mind. Otherwise if you're a
             indexpatient just decide route by state from JWT bools only.
             - NEW (2021-08-24) Third option is a secondary caregiver.
             - We call 2 methods and show a modal and hide other content for them.
          */
          if (this.isSecondaryCaregiver) {
            this.getSecondaryCaregiverConsent()
            this.getSecondaryCaregiverChildren()
          } else if (!this.isIndexPatient && !this.isSecondaryCaregiver && !this.isCardioPatient) {
            this.getScreeningAnswers()
          } else {
            this.decideRouteByState()
          }
          this.metaVerified = true
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          loader.hide()
          this.$router.push({ name: 'error',
            params: { '0': 'error', type: 'login', message: 'POST /token went wrong, unauthorized' }})
        } else {
          loader.hide()
          this.$router.push({ name: 'error',
            params: { '0': 'error', type: 'login', message: 'POST /token went wrong, unauthorized' }})
        }
      })
    },
    checkJwt () {
      const thirtyMinutes = 1800000
      setInterval(() => {
        tokenWatcher()
      }, thirtyMinutes)
    },
    checkIfDirty () {
      if ((this.careGiver.phonenumber && this.careGiver.phonenumber.length === 10) || this.validEmail(this.careGiver.email)) {
        return true
      }
    },
    toTitleCase (phrase) {
      if (phrase) {
        return phrase
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      }
    },
    routeToConsentMinor (event) {
      if (event) {
        window.location.href = window.location.origin + '/consentminor/' + parseInt(event.target.value)
      }
    },
    closeModal () {
      sessionStorage.clear()
      localStorage.removeItem('registerRelative')
      localStorage.removeItem('selectedRelatives')
      localStorage.removeItem('remittance')
      localStorage.removeItem('uri')
      localStorage.removeItem('age')
      localStorage.removeItem('reg')
      document.location.href = '/'
    },
    getConsentStatus (c) {
      if (c) {
        // If minor child (<13), check both consents - otherwise consent for research is viable (13-15)
        if ((c.below13 && c.consentScreening === null) || c.consentResearch === null) {
          return 'consent-to-give-remains'
        } else {
          return 'consent-to-give-finished'
        }
      }
      return ''
    },
    getSecondaryCaregiverConsent () {
      axios._get(config.secondaryCaregiverUri + config.consentUri).then(response => {
        this.secondaryCaregiverConsent = response.data.consent
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get secondary caregiver consent: ' + error)
          this.$store.commit('setVisibility', true)
          setTimeout(() => this.$store.commit('setVisibility', false), config.msInterval)
        }
      })
    },
    giveSecondaryCaregiverConsent () {
      let loader = this.$loading.show()
      this.secondaryCaregiverConsent = true
      axios.postConsent(config.secondaryCaregiverUri + config.consentUri, this.secondaryCaregiverConsent).then((response) => {
        if (response) {
          loader.hide()
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        } else {
          loader.hide()
          console.log(error)
          this.$store.commit('setVisibility', true)
          setTimeout(() => this.$store.commit('setVisibility', false), config.msInterval)
        }
      })
    },
    enforceNumbers () {
      this.research = null
      this.careGiver.phonenumber = this.careGiver.phonenumber.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
    },
    validEmail (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    getPatientRole (djwt) {
      for (const [key, value] of Object.entries(djwt)) {
        if (key.includes('claims') && value === 'IndexPatient') {
          this.isIndexPatient = true
        }
        if (key.includes('claims') && value === 'Relative') {
          this.isRelative = true
        }
        if (key.includes('claims') && value === 'SecondaryCaregiver') {
          this.isSecondaryCaregiver = true
        }
        if (key.includes('claims') && value === 'CardioPatient') {
          this.isCardioPatient = true
        }
        if (key === 'isGeneNegative') {
          this.isGeneNegative = (value === 'true')
          sessionStorage.setItem('isGeneNegative', value)
        }
      }
    },
    registerRelative (notDev) {
      const registrationData = JSON.parse(localStorage.getItem('reg'))
      const sessionId = sessionStorage.getItem('sessionId')
      const uri = config.sessionUri + '/' + sessionId
      if (registrationData) {
        axios._get(uri).then((response) => {
          if (response) {
            registrationData.ssn = response.data.personalId
            axios.postRegistration(config.relativeUri + config.registrationUri, registrationData).then((response) => {
              if (response) {
                this.hasRegistered = true
                localStorage.removeItem('reg')
                localStorage.removeItem('registerRelative')
                if (notDev) {
                  this.getTokenWithMetaInfo()
                }
              }
            }, (error) => {
              if (error.response && error.response.status === 401) {
                window.location.href = window.location.origin.concat('/error')
              } else {
                if (error.response.data && error.response.data[0].includes('Relative already registred')) {
                  sessionStorage.setItem('relativeAlreadyRegistered', true)
                  setTimeout(() => {
                    window.location.href = window.location.origin.concat('/login')
                  }, config.msInterval)
                } else {
                  setTimeout(() => {
                    $('.alert-register').show()
                  }, config.msInterval)
                }
              }
            })
          }
        }, (error) => {
          if (error.response && error.response.status === 401) {
            console.log(error.response)
            this.$router.push({ name: 'error',
              params: { '0': 'error', type: 'login', message: 'POST /token went wrong, unauthorized' }})
          } else {
            this.$router.push({ name: 'error',
              params: { '0': 'error', type: 'login', message: 'POST /token went wrong, unauthorized' }})
          }
        })
      }
    },
    getScreeningAnswers () {
      axios._get(config.screeningAnswerUri).then(response => {
        if (response) {
          const diagnosis = response.data.answers.find(answ => answ.fieldId === 1722201)
          const gentest = response.data.answers.find(answ => answ.fieldId === 1722955)
          const mutation = response.data.answers.find(answ => answ.fieldId === 1723082)
          const vegan = response.data.answers.find(answ => answ.fieldId === 8963171)
          if (diagnosis) {
            this.answers.push(JSON.parse(diagnosis.answer))
          }
          if (gentest) {
            this.answers.push(JSON.parse(gentest.answer))
          }
          if (mutation) {
            this.answers.push(JSON.parse(mutation.answer))
          }
          if (vegan) {
            this.answers.push(JSON.parse(vegan.answer))
          }
        }
        this.decideRouteByState()
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Request went bad to screeninganswers: ' + error)
        }
      })
    },
    decideRouteByState () {
      let loader = this.$loading.show()
      if (this.isDev || this.isQa) {
        const decodedJwt = parseJwt(sessionStorage.getItem('jwt'))
        this.patientStates.push(
          { name: 'consentscreening', value: (decodedJwt.hasVerifiedConsentScreening === 'true') },
          { name: 'consentsresearch', value: (decodedJwt.hasVerifiedConsentResearch === 'true') },
          { name: 'phonenumber', value: (decodedJwt.hasVerifiedPhoneNumber === 'true') },
          { name: 'invitation', value: (decodedJwt.hasVerifiedInvitation === 'true') },
          { name: 'diagnose', value: (decodedJwt.hasVerifiedDiagnosis === 'true') },
          { name: 'gentest', value: (decodedJwt.hasVerifiedGeneticTest === 'true') },
          { name: 'mutation', value: (decodedJwt.hasVerifiedMutation === 'true') },
          { name: 'referral', value: (decodedJwt.hasBloodTestReferral === 'true') }
        )
      }
      for (var i = 0; i < this.patientStates.length; ++i) {
        var ps = this.patientStates[i]
        /*
          INDEXPATIENT
        */
        if (this.isIndexPatient) {
          if (ps.name === 'consentscreening' && ps.value) {
            this.$router.push('/familytree')
            break
          }
          break
        /*
          GENE NEGATIVE
        */
        } else if (this.isGeneNegative) {
          const vegan = this.answers.find(a => a.question.includes('vegan'))
          if (ps.name === 'consentscreening' && !ps.value) {
            this.$router.push('/welcome')
            break
          }
          if (ps.name === 'phonenumber' && !ps.value) {
            this.$router.push('/confirm')
            break
          }
          if (ps.name === 'invitation' && !ps.value) {
            this.$router.push('/verifyinvite')
            break
          }
          if (ps.name === 'diagnose' && !ps.value) {
            this.$router.push('/verifydiagnose')
            break
          }
          if (ps.name === 'gentest' && !ps.value && !vegan) {
            this.$router.push('/screeningvegan')
            break
          }
        /*
          CARDIOPATIENT
        */
        } else if (this.isCardioPatient) {
          if (ps.name === 'consentscreening' && !ps.value) {
            this.$router.push('/welcome')
            break
          } else {
            this.$router.push('/dashboardcardio')
            break
          }
        /*
          RELATIVE
        */
        } else if (!this.isIndexPatient) {
          if (this.age < 13) {
            this.$router.push('/')
            break
          }
          if (ps.name === 'consentscreening' && !ps.value) {
            this.$router.push('/welcome')
            break
          }
          if (ps.name === 'phonenumber' && !ps.value) {
            this.$router.push('/confirm')
            break
          }
          if (ps.name === 'invitation' && !ps.value) {
            this.$router.push('/verifyinvite')
            break
          }
          if (ps.name === 'diagnose' && !ps.value) {
            this.$router.push('/verifydiagnose')
            break
          }
          if (ps.name === 'diagnose' &&
            (this.answers.length > 0 && this.answers[0].answer === 'Ja' && !this.answers[0].diagnosisyear)) {
            this.$router.push('/verifytimestamp')
            break
          }
          if (ps.name === 'diagnose' &&
            (this.answers.length > 0 && this.answers[0].answer === 'Nej')) {
            this.$router.push('/dashboard')
            break
          }
          if (ps.name === 'gentest' && !ps.value) {
            this.$router.push('/verifygentest')
            break
          }
          if (ps.name === 'gentest' &&
            (this.answers.length > 0 && this.answers[1].answer === 'Ja' && !this.answers[1].facility)) {
            this.$router.push('/verifyfacility')
            break
          }
          if (ps.name === 'gentest' &&
            (this.answers.length > 0 && this.answers[1].answer === 'Nej')) {
            this.$router.push('/dashboard')
            break
          }
          if (ps.name === 'mutation' && !ps.value) {
            this.$router.push('/verifymutation')
            break
          }
          if (ps.name === 'mutation' &&
            (this.answers.length > 0 && this.answers[2].answer === 'Ja')) {
            this.$router.push('/dashboardnf')
            break
          }
          if (ps.name === 'mutation' &&
            (this.answers.length > 0 && this.answers[2].answer === 'Nej')) {
            this.$router.push('/dashboard')
            break
          }
        }
        /* RELATIVE - ALL STATES TRUE (exception for gene negative) */
        if (!this.isGeneNegative) {
          this.$router.push('/dashboard')
        } else {
          this.$router.push('/dashboardnf')
        }
      }
      loader.hide()
    },
    giveConsents () {
      let loader = this.$loading.show()
      axios.postConsent(config.consentUri + config.screeningUri, this.consent).then((response) => {
        if (response) {
          /* If age between 13-15, dont POST consent for research */
          if (this.age > 12 && this.age < 15) {
            loader.hide()
            this.$router.push('/confirm')
          } else {
            axios.postConsent(config.consentUri + config.researchUri, this.research).then((response) => {
              if (response) {
                loader.hide()
                if (!this.research) {
                  this.$router.push('/optout')
                } else {
                  if (this.isIndexPatient) {
                    this.verifyInviteForIdxPatient()
                  } else if (this.isCardioPatient) {
                    this.$router.push('/dashboardcardio')
                  } else {
                    this.$router.push('/confirm')
                  }
                }
              }
            }, (error) => {
              if (error.response && error.response.status === 401) {
                loader.hide()
                window.location.href = window.location.origin.concat('/error')
              } else {
                loader.hide()
                console.log(error)
                this.$store.commit('setVisibility', true)
                setTimeout(() => this.$store.commit('setVisibility', false), config.msInterval)
              }
            })
          }
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        } else {
          loader.hide()
          console.log(error)
          this.$store.commit('setVisibility', true)
          setTimeout(() => this.$store.commit('setVisibility', false), config.msInterval)
        }
      })
    },
    verifyInviteForIdxPatient () {
      axios.postInvite(config.inviteUri, true, '').then((response) => {
        if (response) {
          this.$router.push('/familytree')
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log(error)
        }
      })
    },
    sendNotificationToCareGiver () {
      let loader = this.$loading.show()
      axios.postChildrenbetween13and15(config.childrenbetween13and15Uri, this.careGiver).then((response) => {
        if (response) {
          loader.hide()
          $('.alert-research').show().delay(3000).fadeOut()
          this.minorHasSentNotification = true
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        } else {
          loader.hide()
          console.log(error)
          this.$store.commit('setVisibility', true)
          setTimeout(() => this.$store.commit('setVisibility', false), config.msInterval)
        }
      })
    },
    getSecondaryCaregiverChildren () {
      axios._get(config.secondaryCaregiverUri + config.allChildrenUri).then(response => {
        this.secondaryCaregiverChildren = response.data.childrenConsents
        setTimeout(() => {
          $('#secondaryCaregiverModal').modal({backdrop: 'static', keyboard: false})
        })
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get all children that need consent: ' + error)
          this.$store.commit('setVisibility', true)
          setTimeout(() => this.$store.commit('setVisibility', false), config.msInterval)
        }
      })
    }
  },
  computed: {
    hasConsentToBeGiven () {
      if (this.secondaryCaregiverChildren) {
        return this.secondaryCaregiverChildren.some(c => (c.below13 && c.consentScreening === null) || c.consentResearch === null)
      }
    }
  },
  beforeMount () {
    this.fullname = sessionStorage.getItem('fullname')
    const devLogin = (sessionStorage.getItem('devlogin') === 'true')
    /* Regular flow */
    if (!devLogin) {
      if (localStorage.getItem('registerRelative') === 'true') {
        setTimeout(() => {
          $('#registerModal').modal({backdrop: 'static', keyboard: false})
          setTimeout(() => {
            this.registerRelative(true)
          })
        })
      } else {
        this.getTokenWithMetaInfo()
      }
    /* Dev flow */
    } else {
      const decodedJwt = parseJwt(sessionStorage.getItem('jwt'))
      if (decodedJwt) {
        localStorage.setItem('age', decodedJwt.age)
        this.age = decodedJwt.age
        this.getPatientRole(decodedJwt)
      }
      /* If secondary caregiver */
      if (this.isSecondaryCaregiver) {
        sessionStorage.setItem('isSecondaryCaregiver', this.isSecondaryCaregiver)
        this.getSecondaryCaregiverConsent()
        this.getSecondaryCaregiverChildren()
      /* If cardio patient */
      } else if (this.isCardioPatient) {
        sessionStorage.setItem('isCardioPatient', this.isCardioPatient)
        this.decideRouteByState()
      /* Otherwise indexpatient / relative */
      } else {
        if (!this.isIndexPatient) {
          /* We need to register relatives first so they dont have to use invitationlink after that */
          if (localStorage.getItem('registerRelative') === 'true') {
            setTimeout(() => {
              $('#registerModal').modal({backdrop: 'static', keyboard: false})
              setTimeout(() => {
                this.registerRelative(false)
              })
            })
          } else {
            this.getScreeningAnswers()
          }
        } else {
          sessionStorage.setItem('isIndexPatient', this.isIndexPatient)
          this.decideRouteByState()
        }
      }
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          welcomepage {
            greetingsHeader
            greetingsText
            greetingsTextIdx
            greetingsTextCardio
            personaldataHeader
            personaldataText
            personaldataHeaderIdx
            personaldataTextIdx
            consentDisclaimerText
            consentDisclaimerTextIdx
            consentDisclaimerTextMinor
            consentResearch15to17
            consentResearch18Plus
            consentScreeningText
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#registerModal .modal-header, .modal-footer {
  border: 0;
}
.container {
  margin-top: 75px;
}
.btn-group {
  display: flex;
}
.radio-btn {
  border-color: #069ccc;
  background: #fff;
  color: #069ccc;
  font-size: 1em;
  border-radius: .3rem !important;
}
.invalid {
  border: 2px solid red;
}
.alert-research, .alert-register {
  display: none;
}
.card {
  padding: 2rem;
}
.register-card {
  background: #e5f1f5;
  border-radius: 8px;
}
.header-wrapper {
  display: flex;
}
.wrapper-margin-top {
  margin-top: 5rem;
}
.left-header {
  text-align: left;
}
.form-check-input {
  transform: scale(2);
}
.btn-group-disabled {
  opacity: 0.3;
  pointer-events: none;
}
@media screen and (min-width: 800px) {
  .margin-right-2 {
    margin-right: 4% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Welcome.vue